import { AHIcon, AHText, AHTextFonts, TouchableBox } from "arkh";
import React from "react";

import { PLUListItemSpacer } from "../PLUListItemSpacer";
import { usePLUProductItemLayout } from "./PLUProductItemLayout";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export function PLUAddProductItem(props: {
  onPress(): void;
  itemWidth: number;
}) {
  const pluProductItemLayout = usePLUProductItemLayout();
  const intl_tokens = useIntlTokens();
  return (
    <PLUListItemSpacer itemWidth={props.itemWidth}>
      <TouchableBox
        style={{
          height: pluProductItemLayout.height,
          overflow: "hidden",
          borderWidth: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
        cornerRadius="medium"
        borderColor="primary"
        onPress={props.onPress}
      >
        <AHIcon type="add" color="primary" size="xlarge" />
        <AHText
          type="title-small"
          font={AHTextFonts.REGULAR}
          color="primary"
          spaceTop="medium"
        >
          {intl_tokens.AddProduct}
        </AHText>
      </TouchableBox>
    </PLUListItemSpacer>
  );
}
